module.exports = __webpack_public_path__ + "img/web-ad.9456c3f8.svg";